<template>
  <div class="container-root">
    <div class="my-6 d-flex justify-space-between align-center">
      <div class="option-switcher">
        <div
          v-for="(item, i) in types"
          :key="i"
          :class="item.value === type ? 'label-wrapper' : 'label-container'"
          @click="type = item.value"
        >
            <div class="label">{{ item.text }}</div>
        </div>
      </div>
        <CdAutocomplete
          v-model="voucher"
          width="158.35px"
          :items="vouchers"
          itemText="text"
          return-object
        ></CdAutocomplete>
        <CdSelect
          v-model="currency"
          width="158.35px"
          :items="itemsCurrency"
        ></CdSelect>
    </div>
    <CustomerData></CustomerData>
    <AddProduct class="my-6"></AddProduct>
    <OtherDataOrder></OtherDataOrder>
  </div>
</template>
<script>
import CustomerData from './CustomerData.vue'
import AddProduct from './AddProduct.vue'
import OtherDataOrder from './OtherDataOrder.vue'
import CdSelect from '@/components/cdInputs/CdSelect.vue'
import CdAutocomplete from '@/components/cdInputs/CdAutocomplete.vue'

export default {
  name: 'NewOrderMain',
  components: { AddProduct, OtherDataOrder, CustomerData, CdSelect, CdAutocomplete },
  props: {
    // Aquí es donde se declararían las propiedades de tu componente
  },
  data () {
    return {
      types: [
        { text: 'Orden de trabajo', value: '13' },
        { text: 'Proforma', value: '11' }
      ],
      type: '13',
      itemsCurrency: [
        { text: 'Colones', value: 'CRC' },
        { text: 'Dólares', value: 'USD' }
      ],
      voucher: null
    }
  },
  computed: {
    currency: {
      get () {
        return this.$store.state['1'].currency
      },
      set (val) {
        this.$store.commit('1/setCurrency', val)
      }
    },
    vouchers () {
      return this.$store.getters['vouchers/getVouchers'].filter(voucher => {
        return voucher.documentType === '11'
      }).map(voucher => {
        return { key: voucher.key, text: voucher.data.receiver?.name }
      })
    }
    // Aquí es donde se declararían las funciones computadas de tu componente
  },
  watch: {
    voucher (val) {
      if (val && val.key) {
        this.$store.dispatch('1/setVoucher', val.key)
      }
    },
    type (val) {
      if (val) {
        this.$store.dispatch('1/setVoucherType', val)
      }
    }
  },
  methods: {
    // Aquí es donde se declararían los métodos de tu componente
  },
  beforeCreate () {
    // Acciones antes de crear el componente
  },
  created () {
    // Acciones al crear el componente
  },
  beforeMount () {
    // Acciones antes de montar el componente
  },
  mounted () {
    // Acciones al montar el componente
  },
  beforeUpdate () {
    // Acciones antes de actualizar el componente
  },
  updated () {
    // Acciones al actualizar el componente
  },
  beforeDestroy () {
    // Acciones antes de destruir el componente
  },
  destroyed () {
    // Acciones al destruir el componente
  }
}
</script>
<style scoped>
.container-root {
  width: 645px;
  gap: 20.924px;
  margin: 0 auto;
}
.option-switcher {
  border-radius: 24px;
  background-color: #efeffd;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 2px;
  font-size: 14px;
  color: #4361ee;
  font-family: Roboto;
}
.label {
  position: relative;
  letter-spacing: 0.1px;
  line-height: 24px;
  font-weight: 500;
}
.label-wrapper {
  box-shadow: 0px 4px 16px rgba(67, 97, 238, 0.5);
  border-radius: 24px;
  background-color: #4b4ded;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  color: #fff;
}
.parent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  text-align: left;
  color: #2a3256;
}
.label-container {
  border-radius: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  cursor: pointer;
}
/* Aquí es donde se escribiría el CSS específico de tu componente */
</style>
